module.exports = __webpack_public_path__ + "static/accounts_gcp_1-0d004f302dd2e248fa5b4c8c60e3dffc.png";